import {IReservationsFilter} from "./IReservationsFilter";
import {Reservation} from "../../../../../server/src/base/entities/leasing/calendar/Reservation";

export class ReservationFilter implements IReservationsFilter{

    private firstValidDate:Date;
    private lastValidDate:Date;

    constructor(firstValidDate: Date, lastValidDate: Date) {
        this.firstValidDate = firstValidDate;
        this.lastValidDate = lastValidDate;
    }

    public IsValid(value: Reservation): boolean {
        return (value.slot.Date() >= this.firstValidDate) &&
            (value.slot.Date() <= this.lastValidDate);
    }

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/leasing/ReservationFilter.ts